import * as signalR from '@microsoft/signalr'
import { HttpClient as HttpClientSignalR, HubConnection, LogLevel } from '@microsoft/signalr'
import { filter, map, share } from 'rxjs/operators'
import { environment } from '@env'
import { lastValueFrom, Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { RETRY_POLICY } from './signalr.constants'
import { selectToken } from '@domains/profile'
import { inject } from '@angular/core'

export function SignalrFactory(): Observable<HubConnection> {
  const _http = inject(HttpClient)

  let instance: HubConnection

  const options = {
    httpClient: <HttpClientSignalR>{
      getCookieString: (_: string) => '',
      post: (url) =>
        lastValueFrom(_http.post(url, null)).then(
          (res) => ({
            statusCode: 200,
            statusText: null,
            content: JSON.stringify(res),
          }),
          (err) => err,
        ),
    },
    skipNegotiation: true,
    transport: signalR.HttpTransportType.WebSockets,
  }

  // The token comes from the migrated profile selectors (OidcStore-backed
  // projection with the classic `Store.select` emission semantics).
  return selectToken().pipe(
    filter((t) => !!t),
    map((token: string) => {
      if (!instance) {
        instance = new signalR.HubConnectionBuilder()
          .withUrl(environment.api.webSocket(token, environment.apiTvDomain), options)
          .withAutomaticReconnect(RETRY_POLICY)
          .configureLogging(environment.production ? LogLevel.Information : LogLevel.Debug)
          .build()
      }
      return instance
    }),
    share(),
  )
}
